/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 648);
/******/ })
/************************************************************************/
/******/ ({

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var editor_1 = __webpack_require__(390);
/**
 * Base class from which all editor drivers must be derived
 */

var EditorDriver = function (_editor_1$default) {
  _inherits(EditorDriver, _editor_1$default);

  function EditorDriver() {
    _classCallCheck(this, EditorDriver);

    return _possibleConstructorReturn(this, (EditorDriver.__proto__ || Object.getPrototypeOf(EditorDriver)).apply(this, arguments));
  }

  _createClass(EditorDriver, [{
    key: "alert",

    /**
     * If the editor has some form of alert or notifications system, override
     * this so the native notifications are used.
     * @param message Message to be alerted to the user.
     */
    value: function alert(message) {
      window.alert(message);
    }
    /**
     * If the editor supports a 'loading' state which shows a spinner or some
     * progress indicator, this should be implemented.
     *   - If `true` is passed as an arg, the editor's state should be loading.
     *   - If `false` is passed as an arg, the editor's state should be not loading.
     *   - If no args are passed, the editor's loading state should be toggled to
     *   the opposite of what it currently is.
     * @param _loading Optional argument to explicitly set the loading state
     */

  }, {
    key: "setLoadingState",
    value: function setLoadingState(_loading) {
      return;
    }
  }]);

  return EditorDriver;
}(editor_1.default);

exports.default = EditorDriver;

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable no-stateless-class

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var EditorEvents;
(function (EditorEvents) {
    /**
     * Bind and emit this if the editor supports keyboard shortcuts. Keyboard
     * shortcut for this should be cmd/ctrl+alt+r
     */
    EditorEvents["ADD_REFERENCE"] = "ADD_REFERENCE";
    /**
     * Emit this any time the editor becomes available again after being
     * unavailable (excluding the initial initialization).
     */
    EditorEvents["AVAILABLE"] = "EDITOR_AVAILABLE";
    /**
     * Emit this when user manually deletes one or more inline citations using
     * the keyboard.
     */
    EditorEvents["CITATION_DELETED"] = "CITATION_DELETED";
    /**
     * Bind and emit to this if the editor supports keyboard shortcuts.
     * Keyboard shortcut for this should be cmd/ctrl+alt+p
     */
    EditorEvents["TOGGLE_PINNED"] = "TOGGLE_PINNED";
    /**
     * Emit this any time the editor goes unavailable or becomes hidden.
     */
    EditorEvents["UNAVAILABLE"] = "EDITOR_UNAVAILABLE";
    /**
     * Emit this any time the user performs an "undo" in the editor.
     */
    EditorEvents["UNDO"] = "UNDO";
})(EditorEvents || (EditorEvents = {}));

var Editor = function () {
    function Editor() {
        _classCallCheck(this, Editor);
    }

    _createClass(Editor, null, [{
        key: "createBibliographyElement",
        value: function createBibliographyElement(_ref, items) {
            var _ref$heading = _ref.heading,
                heading = _ref$heading === undefined ? '' : _ref$heading,
                _ref$headingLevel = _ref.headingLevel,
                headingLevel = _ref$headingLevel === undefined ? 'h3' : _ref$headingLevel,
                _ref$style = _ref.style,
                style = _ref$style === undefined ? 'fixed' : _ref$style;

            var _bib$classList;

            var classNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

            var bib = document.createElement('div');
            bib.id = Editor.bibliographyId;
            bib.setAttribute('data-reflist', JSON.stringify(items.map(function (_ref2) {
                var id = _ref2.id;
                return id;
            })));
            (_bib$classList = bib.classList).add.apply(_bib$classList, [Editor.bibliographyId].concat(_toConsumableArray(classNames)));
            if (bib.classList.contains(Editor.staticBibClass)) {
                bib.classList.remove(Editor.bibliographyId);
                bib.removeAttribute('id');
                // Occurs only when attempting to insert a static list when the
                // user's selected citation type doesn't define a bibliography.
                if (items.length === 0) {
                    var warnings = top.ABT.i18n.errors.warnings;

                    bib.innerHTML = "<strong>" + warnings.warning + ":</strong> " + warnings.noBib + ".";
                    return bib;
                }
            }
            if (heading) {
                var headingElement = void 0;
                if (style === 'toggle') {
                    headingElement = document.createElement('button');
                    headingElement.classList.add(Editor.bibliographyId + "__heading", Editor.bibliographyId + "__heading_toggle");
                    headingElement.setAttribute('aria-expanded', 'false');
                    headingElement.setAttribute('aria-controls', this.bibliographyId + "__container");
                    headingElement.setAttribute('data-heading-level', headingLevel);
                } else {
                    headingElement = document.createElement(headingLevel);
                    headingElement.classList.add(Editor.bibliographyId + "__heading");
                }
                headingElement.textContent = heading;
                bib.appendChild(headingElement);
            }
            var container = document.createElement('div');
            container.id = this.bibliographyId + "__container";
            container.classList.add(this.bibliographyId + "__container");
            bib.appendChild(container);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var itemMeta = _step.value;

                    var item = document.createElement('div');
                    item.id = itemMeta.id;
                    item.innerHTML = itemMeta.html;
                    container.appendChild(item);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return bib;
        }
    }, {
        key: "createFootnoteSection",
        value: function createFootnoteSection(footnotes) {
            var _note$classList;

            var classNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var note = document.createElement('div');
            note.id = Editor.footnoteId;
            (_note$classList = note.classList).add.apply(_note$classList, [Editor.footnoteId].concat(_toConsumableArray(classNames)));
            var heading = document.createElement('div');
            heading.classList.add(Editor.footnoteId + "__heading");
            heading.textContent = top.ABT.i18n.misc.footnotes;
            note.appendChild(heading);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Array.from(footnotes.entries())[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _ref3 = _step2.value;

                    var _ref4 = _slicedToArray(_ref3, 2);

                    var index = _ref4[0];
                    var footnote = _ref4[1];

                    var item = document.createElement('div');
                    item.classList.add(Editor.footnoteId + "__item");
                    var itemNumber = document.createElement('span');
                    itemNumber.classList.add(Editor.footnoteId + "__number");
                    itemNumber.textContent = "[" + (index + 1) + "]";
                    var itemContent = document.createElement('span');
                    itemContent.classList.add(Editor.footnoteId + "__content");
                    itemContent.innerHTML = footnote;
                    item.appendChild(itemNumber);
                    item.appendChild(itemContent);
                    note.appendChild(item);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return note;
        }
    }, {
        key: "createInlineElement",
        value: function createInlineElement(_a) {
            var _element$classList;

            var _a$classNames = _a.classNames,
                classNames = _a$classNames === undefined ? [] : _a$classNames,
                options = __rest(_a, ["classNames"]);

            var id = options.id,
                innerHTML = options.innerHTML,
                reflist = options.reflist;

            var element = document.createElement('span');
            element.id = id;
            (_element$classList = element.classList).add.apply(_element$classList, [Editor.citationClass].concat(_toConsumableArray(classNames)));
            element.innerHTML = innerHTML;
            element.setAttribute('data-reflist', reflist);
            if (options.kind === 'note') {
                element.setAttribute('data-footnote', options.footnote);
            }
            return element;
        }
    }]);

    return Editor;
}();

Editor.events = EditorEvents;
Editor.bibliographyId = 'abt-bibliography';
Editor.citationClass = 'abt-citation';
Editor.footnoteId = 'abt-footnote';
Editor.staticBibClass = 'abt-static-bib';
exports.default = Editor;

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = __webpack_require__(368);

var TinyMCEDriver = function (_base_1$default) {
    _inherits(TinyMCEDriver, _base_1$default);

    function TinyMCEDriver() {
        _classCallCheck(this, TinyMCEDriver);

        /**
         * `MutationObserver` which watches and reacts to removals of individual
         * citation nodes.
         */
        var _this = _possibleConstructorReturn(this, (TinyMCEDriver.__proto__ || Object.getPrototypeOf(TinyMCEDriver)).apply(this, arguments));

        _this.editorCitationObserver = new MutationObserver(function (mutations) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var mutation = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = Array.from(mutation.removedNodes)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var removedNode = _step2.value;

                            if (removedNode.nodeName !== 'SPAN') {
                                continue;
                            }
                            var classList = removedNode.attributes.getNamedItem('class');
                            if (!classList) {
                                continue;
                            }
                            if (classList.value.split(' ').includes(base_1.default.citationClass)) {
                                dispatchEvent(new CustomEvent(base_1.default.events.CITATION_DELETED));
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        /**
         * Small helper that caches the most previous selection content and
         * bookmark when the editor loses focus.
         */
        _this.selectionCache = {
            /**
             * True if focus is currently outside of the editor. Otherwise a
             * non-cached selection should be used
             */
            fresh: false,
            /** Content currently selected (HTML) */
            selection: '',
            bookmark: { rng: document.createRange() }
        };
        return _this;
    }

    _createClass(TinyMCEDriver, [{
        key: "alert",
        value: function alert(message) {
            this.editor.windowManager.alert(message);
        }
    }, {
        key: "composeCitations",
        value: function composeCitations(clusters, citationByIndex, kind) {
            this.editor.focus();
            var doc = this.editor.getDoc();
            var oldElements = doc.querySelectorAll("\n            #" + base_1.default.footnoteId + ",\n            #" + base_1.default.bibliographyId + "\n        ");
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = Array.from(oldElements)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var old = _step3.value;

                    if (old.parentElement) {
                        old.parentElement.removeChild(old);
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = clusters[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _ref = _step4.value;

                    var _ref2 = _slicedToArray(_ref, 3);

                    var index = _ref2[0];
                    var content = _ref2[1];
                    var id = _ref2[2];

                    var citation = doc.getElementById(id);
                    var innerHTML = kind === 'note' ? "[" + (index + 1) + "]" : content;
                    var reflist = JSON.stringify(citationByIndex[index].citationItems.map(function (c) {
                        return c.id;
                    }));
                    if (citation) {
                        citation.innerHTML = innerHTML;
                        citation.dataset.reflist = reflist;
                        citation.dataset.footnote = kind === 'note' ? content : undefined;
                    } else {
                        this.editor.insertContent(base_1.default.createInlineElement({
                            classNames: ['noselect', 'mceNonEditable'],
                            footnote: kind === 'note' ? content : undefined,
                            id: id,
                            innerHTML: innerHTML,
                            kind: kind,
                            reflist: reflist
                        }).outerHTML);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return kind === 'note' ? this.composeFootnotes() : void 0;
        }
    }, {
        key: "init",
        value: function init() {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this2 = this;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt("return", new Promise(function (resolve, reject) {
                                    var attempts = 0;
                                    var interval = setInterval(function () {
                                        if (top.tinyMCE === undefined) {
                                            attempts += 1;
                                            if (attempts === 10) {
                                                clearInterval(interval);
                                                return reject(new Error("TinyMCE editor doesn't appear to be available in this scope"));
                                            }
                                        } else {
                                            clearInterval(interval);
                                            if (top.tinyMCE.editors && top.tinyMCE.editors.content && top.tinyMCE.editors.content.initialized) {
                                                _this2.editor = top.tinyMCE.editors.content;
                                                _this2.bindEvents();
                                                return resolve();
                                            }
                                            interval = setInterval(function () {
                                                if (top.tinyMCE.editors.content && top.tinyMCE.editors.content.initialized) {
                                                    clearInterval(interval);
                                                    _this2.editor = top.tinyMCE.editors.content;
                                                    _this2.bindEvents();
                                                    return resolve();
                                                }
                                            }, 200);
                                        }
                                    }, 500);
                                }));

                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    }, {
        key: "removeItems",
        value: function removeItems(itemIds) {
            var doc = this.editor.getDoc();
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = itemIds[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var id = _step5.value;

                    var item = doc.getElementById(id);
                    if (item && item.parentElement) {
                        item.parentElement.removeChild(item);
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }
    }, {
        key: "reset",
        value: function reset() {
            var elements = this.editor.getDoc().querySelectorAll("#" + base_1.default.bibliographyId + ", ." + base_1.default.citationClass);
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = Array.from(elements)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var element = _step6.value;

                    if (element.parentElement) {
                        element.parentElement.removeChild(element);
                    }
                }
                // Required to allow tinymce to consume changes
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            this.editor.insertContent('');
        }
    }, {
        key: "setBibliography",
        value: function setBibliography(options, bibliography) {
            var staticBib = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            return staticBib ? this.setStaticBibliography(bibliography) : this.setStandardBibliography(options, bibliography);
        }
    }, {
        key: "setLoadingState",
        value: function setLoadingState(loading) {
            this.editor.setProgressState(loading || false);
        }
    }, {
        key: "bindEvents",
        value: function bindEvents() {
            var _this3 = this;

            this.editor.on('focusin', function () {
                _this3.selectionCache = Object.assign({}, _this3.selectionCache, { fresh: false });
            });
            this.editor.on('focusout', function () {
                _this3.selectionCache = {
                    fresh: true,
                    selection: _this3.selection,
                    bookmark: _this3.editor.selection.getBookmark(1)
                };
            });
            this.editor.on('hide', function () {
                dispatchEvent(new CustomEvent(base_1.default.events.UNAVAILABLE));
            });
            this.editor.on('show', function () {
                dispatchEvent(new CustomEvent(base_1.default.events.AVAILABLE));
            });
            this.editor.on('Undo', function () {
                dispatchEvent(new CustomEvent(base_1.default.events.UNDO));
            });
            this.editor.addShortcut('meta+alt+r', 'Add Reference', function () {
                return dispatchEvent(new CustomEvent(base_1.default.events.ADD_REFERENCE));
            });
            this.editor.addShortcut('meta+alt+p', 'Pin Reference List', function () {
                return dispatchEvent(new CustomEvent(base_1.default.events.TOGGLE_PINNED));
            });
            this.editorCitationObserver.observe(this.editor.getBody(), {
                childList: true,
                subtree: true
            });
        }
    }, {
        key: "composeFootnotes",
        value: function composeFootnotes() {
            var doc = this.editor.getDoc();
            var orderedFootnotes = [].concat(_toConsumableArray(doc.querySelectorAll("." + base_1.default.citationClass).entries())).reduce(function (prev, _ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    idx = _ref4[0],
                    item = _ref4[1];

                item.innerHTML = "[" + (idx + 1) + "]";
                var footnote = item.getAttribute('data-footnote');
                return footnote ? [].concat(_toConsumableArray(prev), [footnote]) : prev;
            }, []);
            if (orderedFootnotes.length === 0) {
                return;
            }
            var bookmark = this.editor.selection.getBookmark();
            var note = base_1.default.createFootnoteSection(orderedFootnotes, ['noselect', 'mceNonEditable']);
            var body = this.editor.getBody();
            this.editor.selection.setCursorLocation(body, body.childNodes.length);
            this.editor.insertContent(note.outerHTML);
            this.editor.selection.moveToBookmark(bookmark);
        }
    }, {
        key: "setStandardBibliography",
        value: function setStandardBibliography(options, bibliography) {
            if (typeof bibliography === 'boolean' || bibliography.length === 0) return;
            var bib = base_1.default.createBibliographyElement(options, bibliography, ['noselect', 'mceNonEditable']);
            var bookmark = this.editor.selection.getBookmark();
            var body = this.editor.getBody();
            this.editor.selection.setCursorLocation(body, body.childNodes.length);
            this.editor.insertContent(bib.outerHTML);
            this.editor.selection.moveToBookmark(bookmark);
        }
    }, {
        key: "setStaticBibliography",
        value: function setStaticBibliography(bibliography) {
            var items = typeof bibliography === 'boolean' ? [] : bibliography;
            var staticBib = base_1.default.createBibliographyElement({}, items, ["" + base_1.default.staticBibClass, 'noselect', 'mceNonEditable']);
            if (this.selectionCache.fresh) {
                this.editor.selection.moveToBookmark(this.selectionCache.bookmark);
            }
            this.editor.insertContent(staticBib.outerHTML);
        }
    }, {
        key: "citationIds",
        get: function get() {
            var citations = this.editor.getDoc().querySelectorAll("*:not(.mce-offscreen-selection) > ." + base_1.default.citationClass);
            return [].concat(_toConsumableArray(citations)).map(function (c) {
                return c.id;
            });
        }
    }, {
        key: "citationsByIndex",
        get: function get() {
            var doc = this.editor.getDoc();
            var nodes = [].concat(_toConsumableArray(doc.querySelectorAll("\n                *:not(.mce-offscreen-selection) >\n                    ." + base_1.default.citationClass + "\n            ")));
            var isFootnoteType = doc.querySelector("#" + base_1.default.footnoteId) !== null;
            return nodes.reduce(function (prev, citation, index) {
                var reflist = citation.getAttribute('data-reflist');
                if (!reflist) {
                    return prev;
                }
                var refs = JSON.parse(reflist);
                return [].concat(_toConsumableArray(prev), [{
                    citationID: citation.id,
                    citationItems: refs.map(function (ref) {
                        return {
                            id: ref
                        };
                    }),
                    properties: {
                        index: index,
                        noteIndex: isFootnoteType ? 1 : 0
                    }
                }]);
            }, []);
        }
    }, {
        key: "relativeCitationPositions",
        get: function get() {
            var _this4 = this;

            var doc = this.editor.getDoc();
            var bm = this.selectionCache.fresh ? this.selectionCache.bookmark : this.editor.selection.getBookmark(1);
            var startContainer = bm.rng.startContainer;

            var citationNodes = [].concat(_toConsumableArray(doc.querySelectorAll("\n                *:not(.mce-offscreen-selection) >\n                    ." + base_1.default.citationClass + "\n            ")));
            return citationNodes.reduce(function (prev, citation, i) {
                if (!citation.parentNode) {
                    throw new Error('parentNode not defined for citation');
                }
                var position = startContainer.compareDocumentPosition(citation);
                switch (position) {
                    case Node.DOCUMENT_POSITION_PRECEDING:
                        prev.itemsPreceding = [].concat(_toConsumableArray(prev.itemsPreceding), [[citation.id, i]]);
                        break;
                    case Node.DOCUMENT_POSITION_FOLLOWING:
                        prev.itemsFollowing = [].concat(_toConsumableArray(prev.itemsFollowing), [[citation.id, i + 1]]);
                        break;
                    default:
                        citation.parentElement.removeChild(citation);
                        _this4.editor.selection.moveToBookmark(_this4.selectionCache.bookmark);
                }
                return prev;
            }, {
                itemsPreceding: [],
                itemsFollowing: []
            });
        }
    }, {
        key: "selection",
        get: function get() {
            return this.selectionCache.fresh ? this.selectionCache.selection : this.editor.selection.getContent({ format: 'html' });
        }
    }]);

    return TinyMCEDriver;
}(base_1.default);

exports.default = TinyMCEDriver;

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(400);


/***/ })

/******/ });


// WEBPACK FOOTER //
// js/drivers/tinymce.js